import React, { Fragment } from 'react';
import { Button, } from 'reactstrap';
import { useToggle } from 'react-use';
import { pickBy, sumBy, uniqBy, orderBy, chunk, groupBy, get, pick, isEmpty, keyBy, omit, } from 'lodash';
import numeral from 'numeral';
import { useBoolean } from 'react-use';
import fileDownload from 'js-file-download';
import { TextEncoder, } from 'text-encoding';
import { unparse as unparseCsv, } from 'papaparse';
import qs from 'qs';
import { addDays, startOfDay, parse as parseDate, isValid as isValidDate, format as formatDate } from 'date-fns';
import { toast } from 'react-toastify';

import firebase, { functions } from '../../firebase';
import { idWithTenant, getNextShippingRequestId, serial, } from '../../shared/util';
import { batch, getCollectionData, } from '../../shared/firebase';
import { receivingOptions, } from '../../shared/models/receivingRequest';
import { shippingOptions, } from '../../shared/models/shippingRequest';
import { deliveryTimes, prefectures, } from '../../shared/config';
import { newId, getAddressByPostalCode, createProductsWithSkuCheck, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useQueryParams from '../hooks/useQueryParams';
import Page from '../hocs/Page';
import ModelFormModal from '../modals/ModelFormModal';
import ImportButton from '../ImportButton';

const { keys, values, entries } = Object;
const db = firebase.firestore();
const receivingOptionsByLabel = keyBy(entries(receivingOptions).map(([k, v]) => ({ key: k, ...v })), 'label');
const deliveryTimesByFormat = keyBy(entries(deliveryTimes).map(([k, v]) => ({ key: k, ...v })), 'format');
const shippingOptionsByLabel = keyBy(entries(shippingOptions).map(([k, v]) => ({ key: k, ...v })), 'label');

export default Page(function BatchImports (props) {
  const { tenant, } = props;
  const productsRef = tenant.ref.collection('products');
  const receivingRequestsRef = tenant.ref.collection('receivingRequests');
  const shippingRequestsRef = tenant.ref.collection('shippingRequests');
  const sendersRef = tenant.ref.collection('senders');
  const products = useCollectionSubscription(productsRef.orderBy('createdAt', 'desc'), [tenant.id]);
  const productsBySku = keyBy(products, 'sku');
  const productSkus = products.map(_ => _.sku);
  const senders = useCollectionSubscription(sendersRef.orderBy('createdAt'), [tenant.id]);
  const sendersByCode = keyBy(senders, 'code');
  const [lastProduct] = useCollectionSubscription(productsRef.orderBy('createdAt', 'desc').limit(1), [tenant.id]);
  const [lastReceivingRequest] = useCollectionSubscription(receivingRequestsRef.orderBy('createdAt', 'desc').limit(1), [tenant.id]);
  const [lastShippingRequest] = useCollectionSubscription(shippingRequestsRef.orderBy('createdAt', 'desc').limit(1), [tenant.id]);
  const onClickDownloadSampleCsv = () => {
    const data = [
      {
        // 必須
        SKU: 'sku_123456',
        数量: 1,
        郵便番号: '5900001',
        住所: '大阪府堺市堺区遠里小野1-1-1 101',
        宛名: 'テスト太郎',
        電話番号: '080-1111-2222',
        配送日: formatDate(addDays(new Date(), 10), 'yyyy/MM/dd'),
        配送時間: '14-16',
        配送元: senders.find(_ => _.isDefault)?.code || '(配送元の識別名を入力してください)',
        メモ: '',

        // 商品
        商品名: '',
        JANまたはバーコード情報: '',
        品名: '',
        ポスト便希望: '',

        // 入荷依頼
        伝票番号: '',
        入庫オプション: '追加検品,セット',
        検品依頼内容: '割れていないか要確認',
        セット内容: 'AとBを1つずつ',

        // 出荷依頼
        出荷オプション: 'OPP梱包,プチプチ梱包,着払いで出荷',
        注文番号: '',
      },
    ];
    const encoder = new TextEncoder('Shift_JIS', { NONSTANDARD_allowLegacyEncoding: true });
    const content = encoder.encode(unparseCsv(data));
    fileDownload(content, '転送依頼_サンプル.csv');
  };
  const validate = async (rows, chunkIndex, row, i) => {
    const {
      // 必須
      SKU: sku,
      数量: _quantity,
      郵便番号: _postalCode,
      住所: address,
      宛名: name,
      電話番号: _phone,
      配送日: _deliveryDate,
      配送時間: _deliveryTime,
      配送元: senderCode,
      メモ: note,

      // 商品
      商品名: productName,
      JANまたはバーコード情報: barcodeInfo,
      品名: itemName,
      ポスト便希望: _requestsNeko,

      // 入荷依頼
      伝票番号: documentNumber,
      入庫オプション: _receivingOptionValues,
      検品依頼内容: checkNote,
      セット内容: setNote,

      // 出荷依頼
      出荷オプション: _shippingOptionValues = '',
      注文番号: orderNumber = '',
    } = row;
    const postalCode = numeral(_postalCode.replace(/-/g, '')).format('0000000');
    const phone = _phone.replace(/-/g, '');
    const quantity = parseInt(_quantity, 10);
    const deliveryDate = isEmpty(_deliveryDate) ? null : parseDate(_deliveryDate, 'yyyy/MM/dd', startOfDay(new Date()));
    const deliveryTime = get(deliveryTimesByFormat, [_deliveryTime, 'key']);
    const senderId = get(sendersByCode, [senderCode, 'id']);
    const addresses = await (async () => {
      try {
        return await getAddressByPostalCode(postalCode);
      } catch(e) {
        console.log(e);
        return [];
      }
    })();
    const addressData = addresses.find(_ => address.match(prefectures[_.prefecture]) && address.match(_.city));
    const postalCodeMatched = addressData != null;
    const requestsNeko = _requestsNeko === 'はい';
    const documentNumberUniqueness = documentNumber || i.toString();
    const receivingOptionValues = _receivingOptionValues.replace(/\s　/g, '').split(',').filter(_ => _).map(_ => get(receivingOptionsByLabel, [_, 'key']));
    const shippingOptionValues = _shippingOptionValues.replace(/\s　/g, '').split(',').filter(_ => _).map(_ => get(shippingOptionsByLabel, [_, 'key']));

    const errors = [
      sku.match(/\s/) && 'SKUに空白やタブ等が含まれています',
      productsBySku[sku]?.isSet && 'セット品は出荷依頼できません',

      !(quantity >= 0) && '数量が正しくありません',
      !(postalCode || '').match(/^[0-9]{7}$/g) && '郵便番号が正しくありません',
      isEmpty(addresses) && '郵便番号が存在しません',
      !isEmpty(addresses) && !postalCodeMatched && '郵便番号と住所が一致しません',
      !address && '住所は必須です',
      !name && '宛名は必須です',
      (phone && !phone.match(/^\d+$/)) && '電話番号が正しくありません',
      deliveryDate != null && (!isValidDate(deliveryDate) || deliveryDate < startOfDay(addDays(new Date(), 1))) && '配送日が正しくありません',
      !deliveryTime && '配送時間が正しくありません',
      !senderId && '配送元が正しくありません',

      (itemName && itemName.length > 16) && '品名は16文字以内です',
      receivingOptionValues.some(_ => !_) && 'オプションが正しくありません',
      shippingOptionValues.some(_ => !_) && 'オプションが正しくありません',
    ];
    return {
      index: chunkIndex * 10 + i,
      source: row,
      errors: errors.filter(_ => _),
      sku,
      quantity,
      postalCode,
      prefecture: addressData?.prefecture,
      city: addressData?.city,
      address1: address.replace(prefectures[addressData?.prefecture], '').replace(addressData?.city, ''),
      address2: '',
      name,
      phone,
      deliveryDate,
      deliveryTime,
      senderId,
      note,
      productName,
      barcodeInfo,
      itemName,
      requestsNeko,
      documentNumber,
      documentNumberUniqueness,
      receivingOptionValues,
      checkNote,
      setNote,
      shippingOptionValues,
      orderNumber,
    }
  };
  const processRows = async (rows) => {
    const validatedRows = (await chunk(rows.filter(_ => _['SKU']), 10)
      .reduce(async (x, rows, chunkIndex) => {
        const prevs = await x;
        return [...prevs, (await Promise.all(rows.map(validate.bind(null, rows, chunkIndex))))];
      }, Promise.resolve([])))
      .flat();
    if(validatedRows.filter(_ => !isEmpty(_.errors)).length > 0) {
      const encoder = new TextEncoder('Shift_JIS', { NONSTANDARD_allowLegacyEncoding: true });
      const content = encoder.encode(unparseCsv(validatedRows.map((row) => {
        return {
          ...row.source,
          エラー内容: row.errors.join('\n'),
        };
      })));
      fileDownload(content, 'エラー結果.csv');
      throw new Error();
    } else {
      const newSkuRows = uniqBy(
        validatedRows
          .filter(_ => !productSkus.includes(_.sku)),
        'sku',
      ).map((_, i) => ({ ..._, productId: (parseInt(newId(lastProduct), 10) + i).toString() }));
      const rowsForCreate = newSkuRows.map(row => ({
        productId: row.productId,
        sku: row.sku,
        data: {
          ...pick(row, ['sku', 'barcodeInfo', 'requestsNeko']),
          name: row.productName || row.sku,
          itemName: row.itemName || (row.productName || row.sku).slice(0, 10),
          goodInventory: 0,
          ngInventory: 0,
          isAmazonProduct: false,
          shippingSize: null,
          createdAt: new Date(),
        },
      }));
      await createProductsWithSkuCheck(db, productsRef, rowsForCreate);
      const rowsForProcess = validatedRows.map((row) => {
        const newSkuRow = newSkuRows.find(_ => _.sku === row.sku);
        return {
          ...row,
          productId: newSkuRow ? newSkuRow.productId : get(productsBySku, [row.sku, 'id']),
        };
      });
      const shippingGroupedRows = groupBy(rowsForProcess, row => [
        'postalCode', 'prefecture', 'city', 'address1', 'address2',
        'name', 'deliveryDate', 'deliveryTime',
      ].map(_ => row[_]).join('--'));
      await serial(values(shippingGroupedRows), async (rows) => {
        const [row] = rows;
        const items = entries(groupBy(rows, 'productId')).map(([productId, rows]) => ({ productId, quantity: sumBy(rows, 'quantity'), goodQuantity: sumBy(rows, 'quantity') }));
        const id = await getNextShippingRequestId(tenant.ref, db);
        await shippingRequestsRef.doc(id).set({
          type: 'normal',
          ...pick(row, ['postalCode', 'prefecture', 'city', 'address1', 'address2', 'name', 'phone', 'deliveryDate', 'deliveryTime', 'shippingOptionValues', 'orderNumber', 'senderId', 'note']),
          items,
          status: 'initial',
          productIds: items.map(_ => _.productId),
          createdAt: new Date(),
        });
      });

      const receivingGroupedRows = groupBy(rowsForProcess, row => [
        'documentNumberUniqueness',
      ].map(_ => row[_]).join('--'));
      await values(receivingGroupedRows).reduce(async (x, rows, i) => {
        await x;

        const [row] = rows;
        const items = entries(groupBy(rows, 'productId')).map(([productId, rows]) => ({ productId, quantity: sumBy(rows, 'quantity'), }));
        const id = 'W' + (parseInt(newId(lastReceivingRequest), 10) + i).toString();
        await receivingRequestsRef.doc(id).set({
          ...pick(row, ['documentNumber', 'receivingOptionValues', 'checkNote', 'setNote']),
          items: items.map(_ => ({ ..._, goodQuantity: 0, ngQuantity: 0 })),
          status: 'initial',
          productIds: items.map(_ => _.productId),
          createdAt: new Date(),
        });
      }, Promise.resolve());
    }
  };

  return (
    <div className="batch-imports container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-start mb-3">
          <Button onClick={onClickDownloadSampleCsv}>
            <span className="fas fa-download mr-1" />
            転送依頼サンプルCSVダウンロード
          </Button>
          <ImportButton className="ml-2" processRows={processRows} label="転送依頼インポート" />
        </div>
        <div className="alert alert-info">
          <p>
            「商品マスタ登録」「入荷依頼」「出荷依頼」が一括で登録できます。
          </p>
          <p>
            「予約販売」「クラウドファンディング」「受発注商品」などの
            「到着したらすぐに出荷してほしい」という依頼の場合に利用してください。
          </p>
          <p>
            ※SKUがすでに登録されている場合は入出荷のみ作成されます。
            SKUがまだシステムに登録されていないもののみ新規で商品マスタ登録されます。
          </p>
        </div>
      </div>
    </div>
  );
});
